import { COLORS } from './utils/colors';

/**
 * Load graph data from API
 * This will connect to Cloudflare Worker → D1 database
 */
export async function loadGraphData() {
  try {
    // TODO: Replace with your Cloudflare Worker API endpoint
    const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || '/api/bids';
    
    const response = await fetch(API_ENDPOINT);
    
    if (!response.ok) {
      throw new Error(`API request failed: ${response.status}`);
    }
    
    const data = await response.json();
    
    return {
      nodes: data.bids || [],
      edges: data.relationships || []
    };
  } catch (error) {
    console.error('Failed to load graph data:', error);
    
    // Return empty state instead of mock data
    return {
      nodes: [],
      edges: []
    };
  }
}

/**
 * Filter nodes based on user criteria
 */
export function filterNodes(nodes, filters) {
  return nodes.filter(node => {
    // Search query
    if (filters.searchQuery) {
      const query = filters.searchQuery.toLowerCase();
      const searchableText = [
        node.title,
        node.scope,
        node.description,
        node.agency
      ].join(' ').toLowerCase();
      
      if (!searchableText.includes(query)) return false;
    }
    
    // Categories
    if (filters.categories.length > 0) {
      if (!filters.categories.includes(node.category)) return false;
    }
    
    // Agencies
    if (filters.agencies.length > 0) {
      if (!filters.agencies.includes(node.agency)) return false;
    }
    
    // Value range
    if (node.value < filters.minValue) return false;
    if (node.value > filters.maxValue) return false;
    
    return true;
  });
}

/**
 * Get unique categories from nodes
 */
export function getCategories(nodes) {
  return [...new Set(nodes.map(n => n.category))].filter(Boolean);
}

/**
 * Get unique agencies from nodes
 */
export function getAgencies(nodes) {
  return [...new Set(nodes.map(n => n.agency))].filter(Boolean).sort();
}